import { useState } from 'react';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import {
  Avatar,
  Box,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Modal,
  Paper,
  useTheme,
} from '@mui/material';

import objectStore from '../../stores/objectStore';
import ModalObjectCard from './ModalObjectCard';
/* import { IoCloseSharp } from 'react-icons/io5' */

import ImageIcon from '@mui/icons-material/Image';
import WorkIcon from '@mui/icons-material/Work';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';


import RenderSelectedTags from '../settings/tags/RenderSelectedTags';


import logger from '../../utils/logger';
import { getPrice } from '../../utils/priceUtils';
import { getObjectFullInfo } from '../../utils/objectInfoUtils';
import { scopedObjectSource } from '../../tenancy/scopedObjectDto';


function ObjectCardRu({ object, onDelete, viewMode }) {
  const theme = useTheme();
  /* 	const isMobile = useMediaQuery(theme.breakpoints.down('sm')) */

  const [open, setOpen] = useState(false);
  const [imageError, setImageError] = useState(false);
  const source = scopedObjectSource(object.source);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  function getMe() {
    logger.log(JSON.stringify(object));
  }

  // Функция для получения краткого описания (первые 100 символов)
  const getShortDescription = (description) => {
    if (!description) return '';
    return description.length > 100 ? `${description.substring(0, 100)}...` : description;
  };

  const renderContent = () => {
    switch (viewMode) {
      case 'card':
        return (
          <>
            <Card sx={{ maxWidth: 345 }} onClick={handleOpen}>
              <div className="cursor-pointer">
                {import.meta.env.VITE_SHOW_COMPONENT_NAME === 'true' && (
                  <div onClick={() => logger.log('ObjectCardRu Render')}>% ObjectCardRu %</div>
                )}
                <Typography
                  variant="caption"
                  color="text.secondary"
                  gutterBottom
                  sx={{
                    display: 'block',
                    mb: 1,
                    fontSize: '0.7rem',
                    pl: 2,
                    pt: 1,
                  }}>
                  {getObjectFullInfo(object, objectStore.categories)}
                </Typography>
                {/* Условный рендеринг CardMedia или плейсхолдера */}
                {object.photos?.[0]?.imageUrl && !imageError ? (
                  <CardMedia
                    component="img"
                    image={object.photos[0].imageUrl}
                    title={object.renderTitle || 'Изображение объекта'}
                    onError={() => setImageError(true)}
                    sx={{
                      height: 200,
                      width: '100%',
                      objectFit: 'cover',
                      aspectRatio: '1 / 1',
                    }}
                  />
                ) : null}

                <CardContent>
                  <Typography gutterBottom component="div">
                    <div className="text-base font-semibold">{object.renderTitle}</div>
                  </Typography>

                  <Typography gutterBottom component="div" className="text-lg">
                    <div className="text-sm font-light">{object.address}</div>
                  </Typography>
                  {/* <div className="text-sm ">{object.address}</div> */}
                  {object.description && (
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1, mb: 2 }}>
                      {getShortDescription(object.description)}
                    </Typography>
                  )}
                  <div className="flex flex-row justify-between items-baseline mt-3">
                    <p className="font-bold text-base">
                      {getPrice(object.details).value} {getPrice(object.details).suffix}
                    </p>

                    <p className="font-light text-sm">
                      {/* 	{priceKvm}{' '} */}
                      {/* 	{i18nStore.translations.objectCardRu.price1meter} */}
                    </p>
                  </div>
                  <div className="mt-3">
                    <RenderSelectedTags tags={object.details?.tags} />
                  </div>
                  {source && (
                    <Typography gutterBottom variant="h6" component="div">
                      <Typography>
                        <div className="text-sm mt-5 font-light ">
                          Источник: <span className="text-blue-500 font-bold">{source.name}</span>
                        </div>
                      </Typography>
                    </Typography>
                  )}
                </CardContent>

                <CardActions
                  className="flex flex-row justify-end"
                  onClick={(e) => e.stopPropagation()} // Отключаем событие открытия модального окна для кнопок
                >
                  {/* <Button size="smaill" startIcon={<IoShareSocialOutline />}></Button> */}
                  {/* <Button size="small" startIcon={<AiOutlineEdit />}></Button> */}
                </CardActions>
              </div>
            </Card>
          </>
        );

      case 'list':
        return (
          <>
            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
              {import.meta.env.VITE_SHOW_COMPONENT_NAME === 'true' && (
                <div onClick={() => logger.log('ObjectCardRu Render')}>% ObjectCardRu %</div>
              )}

              <ListItem>
                <ListItemAvatar>
                  <Avatar>
                    <ImageIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary="Photos" secondary="Jan 9, 2014" />
              </ListItem>
              <ListItem>
                <ListItemAvatar>
                  <Avatar>
                    <WorkIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary="Work" secondary="Jan 7, 2014" />
              </ListItem>
              <ListItem>
                <ListItemAvatar>
                  <Avatar>
                    <BeachAccessIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary="Vacation" secondary="July 20, 2014" />
              </ListItem>
            </List>
          </>
        );

      default:
        return null;
    }
  };
  return (
    <>
      {renderContent()}

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={(theme) => ({
            position: 'absolute',
            top: '5%',
            left: '50%',
            transform: 'translate(-50%, 0)',
            width: '97%',
            bgcolor: 'background.paper',
            boxShadow: 24,
            borderRadius: 3,
            maxHeight: '95vh',
            overflowY: 'auto',
            scrollbarWidth: 'none',
            '&::-webkit-scrollbar': { display: 'none' },
            [theme.breakpoints.up('sm')]: { width: '80%' },
            [theme.breakpoints.up('md')]: { width: '70%' },
            [theme.breakpoints.up('lg')]: { width: '60%' },
            [theme.breakpoints.up('xl')]: { width: '50%' },
          })}
        >
          <Box sx={{ p: 2 }}>
            <ModalObjectCard
              onClose={handleClose}
              object={object}
              /* title={object.renderTitle} */
              onDelete={onDelete}
              
            />
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default ObjectCardRu;
